module.exports = __webpack_public_path__ + "img/danger.83a27358.svg";